













import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import UiMapCell from '@/components/UiMapCell.vue';
@Component({components: {UiMapCell}})
export default class UiMap extends Vue {

  @Prop() public numberOfBombs!: number;

  private readonly xSize: number = 10;
  private readonly ySize: number = 10;

  private indexedCells: {[coordinate: string]: UiMapCell} = {};
  private numberOfMarkedCells: number = 0;

  // noinspection JSUnusedGlobalSymbols
  public mounted(): void {
    this.placeCells();
    this.placeBombs();
    this.calculateNeighboringCells();
    this.$emit('rendered');
  }

  public get mapXSize(): number {
    return 10;
  }

  public get mapYSize(): number {
    return 10;
  }

  public get mapStyle(): string {
    const width = this.mapXSize * UiMapCell.size + UiMapCell.size / 2;
    const height = this.mapYSize * UiMapCell.size * 0.75 + UiMapCell.size / 4;
    return `width: ${width}px; min-width: ${width}px; height: ${height}px; min-height: ${height}px; line-height: 20px; position: relative;`;
  }

  public verify(): void {
    let numberOfDiscovered: number = 0;
    // @ts-ignore
    this.$refs.cells.forEach((cell: UiMapCell) => {
      if (cell.hasBomb && cell.isDiscovered) {
        this.$emit('failure');
        return;
      }
      if (cell.isDiscovered) {
        numberOfDiscovered++;
      }
    });
    if (numberOfDiscovered === this.xSize * this.ySize - this.numberOfBombs) {
      this.$emit('victory');
    }
  }

  @Watch('numberOfMarkedCells') private onNumberOfMarkedCellsChanged(): void {
    this.$emit('change-number-of-marked-cells', this.numberOfMarkedCells);
  }

  private placeCells(): void {
    let x: number = 0;
    let y: number = 0;
    // @ts-ignore
    this.$refs.cells.forEach((cell: UiMapCell) => {
      cell.x = x;
      cell.y = y;
      this.indexedCells[`${x}_${y}`] = cell;
      x++;
      if (x === this.xSize) {
        x = 0;
        y++;
      }
    });
  }

  private placeBombs(): void {
    const keys = Object.keys(this.indexedCells);
    for (let i = 0; i < this.numberOfBombs; i++) {
      const index = Math.round(Math.random() * (keys.length - 1));
      const key = keys[index];
      this.indexedCells[key].hasBomb = true;
      keys.splice(index, 1);
    }
  }

  private calculateNeighboringCells(): void {
    for (const coordinate of Object.keys(this.indexedCells)) {
      const cell: UiMapCell = this.indexedCells[coordinate];
      this.getNeighboringCells(cell.x, cell.y).forEach((neighboringCell: UiMapCell) => {
        cell.numberOfBombsAround += neighboringCell.hasBomb ? 1 : 0;
      });
    }
  }

  private discoverCell(index: number): void {
    // @ts-ignore
    const currentCell: UiMapCell = this.$refs.cells[index];
    currentCell.isDiscovered = true;
    if (!currentCell.hasBomb && currentCell.numberOfBombsAround === 0) {
      this.discoverSafeAreaAround(currentCell.x, currentCell.y);
    }
    this.verify();
  }

  private getNeighboringCells(x: number, y: number): UiMapCell[] {
    const xModifier = y % 2 === 0 ? -1 : 0;
    const neighboringCoordinates = [
      [x + xModifier, y - 1],
      [x + xModifier + 1, y - 1],
      [x - 1, y],
      [x + 1, y],
      [x + xModifier, y + 1],
      [x + xModifier + 1, y + 1],
    ];
    const neighboringCells: UiMapCell[] = [];
    neighboringCoordinates.forEach((neighboringCoordinate) => {
      const neighboringX = neighboringCoordinate[0];
      const neighboringY = neighboringCoordinate[1];
      if ((neighboringX === x && neighboringY === y)
        || neighboringX < 0 || neighboringY < 0
        || neighboringX >= this.xSize || neighboringY >= this.ySize) {
        return;
      }
      neighboringCells.push(this.indexedCells[`${neighboringX}_${neighboringY}`]);
    });
    return neighboringCells;
  }

  private discoverSafeAreaAround(x: number, y: number): void {
    this.getNeighboringCells(x, y).forEach((neighboringCell: UiMapCell) => {
      if (neighboringCell.isDiscovered) {
        return;
      }
      neighboringCell.isDiscovered = true;
      if (neighboringCell.numberOfBombsAround === 0) {
        this.discoverSafeAreaAround(neighboringCell.x, neighboringCell.y);
      }
    });
  }
}
